import { z } from 'zod'

export const AgreementTermTypes = ['rolling', 'fixed', 'oneOff', 'perpetual'] as const
export const AgreementTermTypeSchema = z.enum(AgreementTermTypes)

export type AgreementTermType = (typeof AgreementTermTypes)[number]
